<template>
  <div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing">
      <h5 class="card-title fw-bold mb-0">Statistiques Colis</h5>

      <div class="row">
        <div class="col-md-8">
          <!-- <rangedate-picker
            ref="myInput"
            format="YYYY-MM-DD"
            i18n="EN"
            :preset-ranges="presetRanges"
            :captions="captions"
          /> -->
        </div>
        <div class="col-md-4">
          <button
            type="button"
            class="btn btn-primary"
            @click="FilterData"
          >
            <i class="flaticon-search"></i>
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="ClearFilterData"
          >
            <i class="flaticon-close"></i>
          </button>
        </div>
      </div>
      <template v-if="show">
        <apexchart
          type="donut"
          height="380"
          :options="chartApex.chartOptions"
          :series="chartApex.series"
        />
      </template>
      <!-- chart info -->
      <!--
      <div class="pt-3">
        <div
          v-for="(data, index) in Data"
          :key="data.name"
          class="d-flex justify-content-between"
          :class="index === Data.length - 1 ? 'mb-0' : 'mb-1'"
        >
          <div
            class="badge badge-outline badge-statut"
            :style="{ '--color': data.code_color }"
          >
            {{ data.name }}
          </div>
          <span :style="{ color: data.code_color }">{{ data.num }} Colis</span>
        </div>
      </div>
      -->
    </div>
  </div>
</template>


<script lang="ts">
import api from "@/utils/axios";
import { defineComponent, ref, reactive } from "vue";

export default defineComponent({
  setup() {
    const chartData = ref({});
    const Data = ref(null);
    const searchEDate = ref("");
    const searchSDate = ref("");
    const show = ref(false);

    const Options = reactive({
      series: [],
      chartOptions: {
        chart: {
          type: "pie",
        },
        labels: [
          "Nouveau Colis",
          "Attente De Ramassage",
          "Ramassé",
          "Expédié",
          "Reçu",
          "Mise en distribution",
          "En cours",
          "Retourné",
          "Livré",
        ],
        colors: [
          "#e2ba73",
          "#FFBA57",
          "#5765ff",
          "#78ceb2",
          "#299900",
          "#db6e14",
          "#E2B509",
          "#EB1A00",
          "#756039",
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val: number) {
            return val.toFixed(2) + "%";
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
                // formatter: function(seriesName, opts) {
                //     return [seriesName, " - ", opts.w.globals.series[opts.seriesIndex]]
                // }
              },
            },
          },
        ],
        // noData: {
        //   text: "There's no data",
        //   align: "center",
        //   verticalAlign: "middle",
        //   offsetX: 0,
        //   offsetY: 0,
        // },
      },
    });

    const chartApex = reactive({
      series: [0, 0, 0, 0, 0, 0, 0, 0, 0],
      chartOptions: {
        chart: {
          width: 380,
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        labels: [
          "Nouveau Colis",
          "Attente De Ramassage",
          "Ramassé",
          "Expédié",
          "Reçu",
          "Mise en distribution",
          "En cours",
          "Retourné",
          "Livré",
        ],
        colors: [
          "#e2ba73",
          "#FFBA57",
          "#5765ff",
          "#78ceb2",
          "#299900",
          "#db6e14",
          "#E2B509",
          "#EB1A00",
          "#756039",
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val: number) {
            return val.toFixed(2) + "%";
          },
        },
        fill: {
          type: "gradient",
        },
        // title: {
        //   text: 'Gradient Donut with custom Start-angle'
        // },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    });

    const getData = async () => {
      try {
        const response = await api.get(
          `/api/auth/client/StatusCount?searchSDate=${searchSDate.value}&searchEDate=${searchEDate.value}`
        );
        Options.series = [];
        Data.value = response.data.data_statut;
        chartApex.series = response.data.nums;
        chartApex.chartOptions.colors = response.data.colors;
        chartApex.chartOptions.labels = response.data.label;
        show.value = true;
      } catch (error) {
        // Handle error as needed
        show.value = false;
      }
    };

    const FilterData = () => {
      // const dateRange = (refs.myInput as any).dateRange || {};
      // searchSDate.value = dateRange.start ? convert(dateRange.start) : '';
      // searchEDate.value = dateRange.end ? convert(dateRange.end) : '';
      getData();
    };

    const ClearFilterData = () => {
      searchSDate.value = "";
      searchEDate.value = "";
      // (refs.myInput as any).dateRange = {};
      getData();
    };

    const sumData = (arr: number[]) => {
      return arr.length ? arr.reduce((acc, cur) => acc + cur, 0) : 0;
    };

    return {
      chartData,
      Data,
      searchEDate,
      searchSDate,
      show,
      Options,
      chartApex,
      ClearFilterData,
      FilterData,
      sumData,
      getData,
    };
  },
});
</script>
